import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import PreviewIcon from '@mui/icons-material/Preview';

import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleMatOutward } from '../../../Store/PHPSlice/MatOutward';

const TableBody = ({
    id: matId,
    serialNumber,
    locNm,
    materialNm,
    description,
    size,
    pkt,
    packetqty,
    totqty,
    stkqty,
    givenqty,
    balqty,
    selected,
    handleClick,
}) => {

    const dispatch = useDispatch();
    const handleViewClick = () => {
        // Replace 'URL' with the actual URL you want to open
        //alert("matId=>"+matId);
        window.open(`/MaterialStockView/${matId}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        const isConfirmed = window.confirm("Are you sure you want to delete this Material Outward?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleMatOutward(matId))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Material Outward Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Material Outward:", error);
                    toast.error("Failed to delete Material Outward");
                });
        }
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{locNm}</TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{materialNm}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{description}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {pkt}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {packetqty}
                </TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totqty}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {stkqty}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{givenqty}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{balqty}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <PreviewIcon className='cursor-pointer' onClick={handleViewClick} />
                </TableCell>



            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
